import angular from "angular";

angular
    .module('app')
    .component('headerComponent', {
        template: require('./header-component.html'),
        controller: ['$uibModal', '$http', 'Auth', '$rootScope', controller],
        bindings: {
            appName: '@',
            type: '@'
        }
    });

function controller($uibModal, $http, Auth, $rootScope) {

    let $ctrl = this;

    $rootScope.$on('UserLoginFromCoursePage', function (event, data) {
        $ctrl.user = data.user;
    });

    $ctrl.$onInit = function () {
        $ctrl.user = Auth.user();
        if (!$ctrl.type) {
            $ctrl.type = 'main';
        }
    };

    $ctrl.openLoginModal = function () {
        $uibModal
            .open({
                component: 'loginForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    $ctrl.user = user;
                    $rootScope.$emit('UserLoginFromHeader', {user});
                },
                function (res) {
                    if (res == 'open-register-form') {
                        $ctrl.openRegisterModal();
                    }
                    if (res == 'open-reset-password-form') {
                        $ctrl.openResetPasswordModal();
                    }
                }
            );
    };

    $ctrl.openRegisterModal = function () {
        $uibModal
            .open({
                component: 'registerForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    $ctrl.user = user;
                    $rootScope.$emit('UserLoginFromHeader', {user});
                },
                function (res) {
                    if (res == 'open-login-form') {
                        $ctrl.openLoginModal();
                    }
                }
            );
    };

    $ctrl.openResetPasswordModal = function () {
        $uibModal
            .open({
                component: 'resetPasswordForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    $ctrl.user = user;
                    $rootScope.$emit('UserLoginFromHeader', {user});
                },
                function (res) {
                    if (res == 'open-login-form') {
                        $ctrl.openLoginModal();
                    }
                    if (res == 'open-register-form') {
                        $ctrl.openRegisterModal();
                    }
                }
            );
    };

    $ctrl.logout = function () {
        $http
            .post('/logout')
            .then(
                function () {
                    window.location = '/';
                },
                function (error) {
                }
            );
    };
}
